import {
  TLineSetupTicketId,
  TREQUEST_LINE_SETUP_TICKET_LISTING,
  TREQUEST_LINE_SETUP_TICKET_SUBTASK_LIST,
  TRESPONSE_GET_LINE_SETUP_TICKET_CURRENT_SETUP,
  TRESPONSE_LINE_SETUP_TICKET_DETAILS,
  TRESPONSE_LINE_SETUP_TICKET_LISTING,
  TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TQcoActionTypes } from './qco.models';

export class GetLineSetupTicketsListing implements Action {
  readonly type = TQcoActionTypes.GetLineSetupTicketsListing;
  constructor(public payload: TREQUEST_LINE_SETUP_TICKET_LISTING, public resetPaginationOption?: boolean) {}
}
export class GetLineSetupTicketsListingSuccess implements Action {
  readonly type = TQcoActionTypes.GetLineSetupTicketsListingSuccess;
  constructor(public payload: TRESPONSE_LINE_SETUP_TICKET_LISTING) {}
}
export class GetLineSetupTicketsListingFailure implements Action {
  readonly type = TQcoActionTypes.GetLineSetupTicketsListingFailure;
  constructor() {}
}

export class GetLineSetupTicketsSubtasks implements Action {
  readonly type = TQcoActionTypes.GetLineSetupTicketsSubtasks;
  constructor(public payload: TREQUEST_LINE_SETUP_TICKET_SUBTASK_LIST) {}
}
export class GetLineSetupTicketsSubtasksSuccess implements Action {
  readonly type = TQcoActionTypes.GetLineSetupTicketsSubtasksSuccess;
  constructor(public payload: TRESPONSE_LINE_SETUP_TICKET_SUBTASK_LIST) {}
}
export class GetLineSetupTicketsSubtasksFailure implements Action {
  readonly type = TQcoActionTypes.GetLineSetupTicketsSubtasksFailure;
  constructor() {}
}

export class FetchLineSetupTicketNewSetup implements Action {
  readonly type = TQcoActionTypes.FetchLineSetupTicketNewSetup;
  constructor(public lineSetupTicketId: TLineSetupTicketId) {}
}
export class FetchLineSetupTicketNewSetupSuccess implements Action {
  readonly type = TQcoActionTypes.FetchLineSetupTicketNewSetupSuccess;
  constructor(public payload: TRESPONSE_LINE_SETUP_TICKET_DETAILS) {}
}
export class FetchLineSetupTicketNewSetupFailure implements Action {
  readonly type = TQcoActionTypes.FetchLineSetupTicketNewSetupFailure;
  constructor() {}
}

export class FetchLineSetupTicketCurrentSetup implements Action {
  readonly type = TQcoActionTypes.FetchLineSetupTicketCurrentSetup;
  constructor(public locationId: number) {}
}
export class FetchLineSetupTicketCurrentSetupSuccess implements Action {
  readonly type = TQcoActionTypes.FetchLineSetupTicketCurrentSetupSuccess;
  constructor(public payload: TRESPONSE_GET_LINE_SETUP_TICKET_CURRENT_SETUP) {}
}
export class FetchLineSetupTicketCurrentSetupFailure implements Action {
  readonly type = TQcoActionTypes.FetchLineSetupTicketCurrentSetupFailure;
  constructor() {}
}

export class SetLineSetupTicketPaginationOption implements Action {
  readonly type = TQcoActionTypes.SetLineSetupTicketPaginationOption;
  constructor(public payload: TUserPaginationOption) {}
}

export type TQcoActions =
  | GetLineSetupTicketsListing
  | GetLineSetupTicketsListingSuccess
  | GetLineSetupTicketsListingFailure
  | GetLineSetupTicketsSubtasks
  | GetLineSetupTicketsSubtasksSuccess
  | GetLineSetupTicketsSubtasksFailure
  | FetchLineSetupTicketNewSetup
  | FetchLineSetupTicketNewSetupSuccess
  | FetchLineSetupTicketNewSetupFailure
  | FetchLineSetupTicketCurrentSetup
  | FetchLineSetupTicketCurrentSetupSuccess
  | FetchLineSetupTicketCurrentSetupFailure
  | SetLineSetupTicketPaginationOption;
